import React from 'react';
import { MaintenanceView } from './view/maintenanceView';

export const MaintenanceContainer = (): React.ReactElement => {
    return (
        <MaintenanceView />
    );
};
